
export default function bestofInit() {
    var bestOfSlider = document.getElementById('slider-best-of');
    var bestOfGrid = document.getElementById('best-of-grid');
    
    if (bestOfSlider) {
        let isScrolling = false;
        
        bestOfSlider.addEventListener("input", (event) => {
            isScrolling = true;
            var width = bestOfGrid.scrollWidth;
            var toScroll = width - bestOfGrid.clientWidth;
            bestOfGrid.scrollTo({
                top: 0,
                left: scale(event.target.value, [0,100], [0, toScroll]),
                behavior: 'smooth'
            }) 
        });
        
        bestOfSlider.addEventListener("change", (event) => {
            setTimeout(() => {
                isScrolling = false;
            }, 400);
        });
        
        bestOfGrid.addEventListener("scroll", function (e) {
            if (isScrolling == false) {
                var width = bestOfGrid.scrollWidth;
                var toScroll = width - bestOfGrid.clientWidth;
                bestOfSlider.value = scale(e.target.scrollLeft, [0,toScroll], [0, 100]);
            }
        });
        
        
        const scale = (number, [inMin, inMax], [outMin, outMax]) => {
            // if you need an integer value use Math.floor or Math.ceil here
            return (number - inMin) / (inMax - inMin) * (outMax - outMin) + outMin;
        }
    }   
}
